import { Component } from '@angular/core';

@Component({
  selector: 'app-block-pms',
  templateUrl: './block-pms.component.html',
  styleUrls: ['./block-pms.component.scss']
})
export class BlockPmsComponent {

}
